import { Box, Text } from "@/ui";
import { useTheme } from "@mui/material";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useSystemContext } from "@/provider/common/SystemProvider";
import { CofidocBilling, fetchCofidocBill } from "@/api/billing/fetchCofidocBill";
import { colorPalette } from "@/theme/ThemeProvider";
import { formatUTC } from "@/utils/format";

export const InvoiceItem = ({ invoice }: { invoice: CofidocBilling }) => {
  const theme = useTheme();
  const { application, getUser } = useSystemContext();
  const isAvoir = invoice.reference?.startsWith("AV");
  const accentColor = isAvoir ? colorPalette.green.dark : theme.palette.primary.main;

  function base64ToBlob(base64, mimeType) {
    // Decode the Base64 string
    const binaryString = atob(base64);

    // Create an array to hold the decoded binary data
    const binaryLength = binaryString.length;
    const bytes = new Uint8Array(binaryLength);

    // Populate the array with binary data
    for (let i = 0; i < binaryLength; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create and return the Blob
    return new Blob([bytes], { type: mimeType });
  }

  const downloadInvoicesByMonth = async (invoice: CofidocBilling) => {
    try {
      const user = getUser();
      const email = user?.email || null;
      const username = user?.identifiant || null;

      const res = await fetchCofidocBill({
        id: invoice.id?.toString(),
        username,
        email,
        application,
      });
      const fileName = `${isAvoir ? "Avoir" : "Facture"}_${formatUTC(invoice?.date, "dd_MM_yyyy")}.pdf`;
      const mimeType = "application/pdf";
      saveAs(base64ToBlob(res?.base64, mimeType), fileName);
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  return (
    <Box
      width="100%"
      p={2}
      mb={2}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      style={{
        cursor: "pointer",
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 8,
        backgroundColor: theme.palette.background.paper,
      }}
      onClick={() => downloadInvoicesByMonth(invoice)}
    >
      <Box flexDirection="row" alignItems="center" flex={1}>
        <InsertDriveFileIcon
          style={{
            color: accentColor,
            fontSize: 32,
            marginRight: 12,
          }}
        />
        <Box flexDirection="column">
          <Text fontSize={14} fontWeight="600" color={theme.palette.text.primary}>
            {isAvoir ? "Avoir" : "Facture"}
          </Text>
          <Text fontSize={12} fontWeight="400" color={theme.palette.text.secondary}>
            {formatUTC(invoice?.date, "dd MMMM yyyy")}
          </Text>
        </Box>
      </Box>
      <Box flexDirection="row" alignItems="center">
        {invoice.amount != null && (
          <Text fontSize={14} fontWeight="600" color={accentColor} style={{ marginRight: 16 }}>
            {parseFloat(invoice.amount).toFixed(2)} €
          </Text>
        )}
        <DownloadIcon
          style={{
            color: accentColor,
            fontSize: 24,
          }}
        />
      </Box>
    </Box>
  );
};
